export const hasOneTrustLoaded = () => {
  return typeof window.OnetrustActiveGroups === 'string';
};

const isInOneTrustActiveGroups = (consentCode) => {
  return !!window.OnetrustActiveGroups.includes(consentCode);
};

const isConsentGranted = (consentCode) => {
  return hasOneTrustLoaded() && isInOneTrustActiveGroups(consentCode);
};

export const isOneTrustModalBannerUp = () => {
  const oneTrustModal = document.querySelector('#onetrust-pc-sdk > div[role="dialog"][aria-modal="true"]');
  const oneTrustBanner = document.querySelector(
    '#onetrust-banner-sdk[aria-label="Cookie banner"][style*="bottom: 0px;"] > div[role="dialog"][aria-label="Privacy"]',
  );

  return (
    (oneTrustModal && oneTrustModal.offsetParent !== null) || (oneTrustBanner && oneTrustBanner.offsetParent !== null)
  );
};

export default isConsentGranted;
